import axios from "axios";
import config from "../config";
import useSWR from "swr";
import useSWRImmutable from "swr/immutable";

const axiosToken = () => {
  return {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("QCAPPjwt"),
    },
  };
};
const EssToken = () => {
  return {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("ESSjwt"),
    },
  };
};
// import qs from "qs";
const essUser = async (identifier, password) => {
  const res = await axios.post(
    `${config.ess}/auth/local`,
    {
      identifier,
      password,
    },
    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
  );
  return res;
};
const getEssEmployeeByUser = async (username) => {
  const res = await axios.get(
    `${config.ess}/employees?emp_id=${username}`,
    EssToken(),
    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
  );
  return res;
};
const getEssUserByUser = async (username) => {
  const res = await axios.get(
    `${config.ess}/users?username=${username}`,
    EssToken(),
    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
  );
  return res;
};

const authQCUser = async (identifier, password) => {
  return await axios.post(
    `${config.server}/api/auth/local`,
    {
      identifier,
      password,
    },
    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const getQCUser = async (username) => {
  return await axios.get(
    // `${config.server}/api/users?filters[username][$eq]=${username}&populate=*`,
    `${config.server}/api/users?filters[username][$eq]=${username}&populate[profile_image][fields]=url&populate[signature][fields]=url`,
    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const getPartSlim = async () => {
  return await axios.get(
    `${config.server}/api/qc-parts?sort[0]=id&filters[usePartForAdmin][$eq]=true&populate[image][populate]=*&populate[revise][populate]=*&populate[old_parts]=*`,
    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const getPartByID = async (partId) => {
  return await axios.get(
    // `${config.server}/api/qc-parts/${partId}?populate[sub_categories][populate]=questions&populate[old_parts][fields]=id&populate[sub_categories][populate]=category&populate[image]=*&populate[revise]=*`,
    `${config.server}/api/qc-parts/${partId}?populate[sub_categories][populate]=questions&populate[old_parts][fields]=id&populate[sub_categories][populate]=category&populate[image]=*&populate[revise]=*`,

    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};
const getPartByIdArray = async (partIds) => {
  if (!Array.isArray(partIds)) {
    throw Error("partIds should be array type");
  }
  return await axios({
    method: "POST",
    url: `${config.server}/api/qc-parts/getManyPartTorelance`,
    data: {
      partIds,
    },
  });
};

const getPart = async () => {
  return await axios.get(
    `${config.server}/api/qc-parts?sort[0]=id&filters[usePartForAdmin][$eq]=true&populate[image][populate]=*&populate[old_parts][populate]=*&populate[sub_categories][populate]=*&populate[revise][populate]=*`,

    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
  // return await axios.get(
  //   `${config.server}/api/qc-parts?sort[0]=id&filters[usePartForAdmin][$eq]=true&populate[sub_categories][populate][questions][populate]&populate[image][populate]=*&populate[sub_categories][populate][category][populate]=*&populate[papers][populate]=*&populate[revise][populate]=*&populate[old_parts][populate]=*&populate=*`,
  //   {
  //     validateStatus: function (status) {
  //       return status < 500;
  //     },
  //   },
  //   axiosToken()
  // );
};
const getPartWithRevise = async () => {
  // return await axios.get(
  //   `${config.server}/api/qc-parts?sort[0]=id&filters[usePartForAdmin][$eq]=true&populate[image][populate]=*`,
  //   {
  //     validateStatus: function (status) {
  //       return status < 500;
  //     },
  //   },
  //   axiosToken()
  // );
  return await axios.get(
    `${config.server}/api/qc-parts?sort[0]=id&filters[status][$eq]=true&populate[image][populate]=*&populate[old_parts][populate]=*&populate[revise][populate]=*`,
    //  `${config.server}/api/qc-parts?sort[0]=id&filters[usePartForAdmin][$eq]=true&populate[sub_categories][populate][questions][populate]&populate[image][populate]=*&populate[sub_categories][populate][category][populate]=*&populate[papers][populate]=*&populate[revise][populate]=*&populate[old_parts][populate]=*&populate=*`,

    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const getSubCategoriesAddCategoriesPage = async (id) => {
  return await axios.get(
    `${config.server}/api/sub-categories?sort[0]=id&filters[part][id][$eq]=${id}&populate[category][populate]=*`,

    axiosToken(),

    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
  );
};

const getSubCategories = async (id) => {
  return await axios.get(
    // `${config.server}/api/sub-categories?filters[part][id][$eq]=${id}&populate=*`,
    // `${config.server}/api/sub-categories?filters[part][id][$eq]=${id}&populate[questions][populate]=*`,
    `${config.server}/api/sub-categories?sort[0]=id&filters[part][id][$eq]=${id}&populate[questions][populate]=*&populate[part][populate]=*&populate[category][populate]=*`,

    axiosToken(),

    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
  );
};

const getSubCategoriesByPartIdSlim = async (id) => {
  return await axios.get(
    `${config.server}/api/sub-categories?sort[0]=id&filters[part][id][$eq]=${id}&populate[questions][populate]=*&populate[part][populate]=*&populate[category][populate][fields]=category`,
    axiosToken(),
    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
  );
};

const getSubCategoriesForViewPaperByPartId = async (id) => {
  return await axios.get(
    // `${config.server}/api/sub-categories?sort[0]=id&filters[part][id][$eq]=${id}&populate[questions][populate]=*&populate[part][populate]=*&populate[category][populate]=*`,
    `${config.server}/api/sub-categories?sort[0]=id&filters[part][id][$eq]=${id}&populate[0]=part&populate[1]=category&populate[2]=questions`,
    axiosToken(),

    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
  );
};

const getSubCategoriesForDashboard = async (id) => {
  return await axios.get(
    `${config.server}/api/sub-categories?sort[0]=id&filters[part][id][$eq]=${id}&populate[category][populate][fields]=category`,
    axiosToken(),
    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
  );
};

const getSubCategoriesSlim = async () => {
  return await axios.get(
    `${config.server}/api/sub-categories?populate[category][fields]=category`,
    axiosToken(),
    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
  );
};

const getCategories = async () => {
  return await axios.get(
    `${config.server}/api/categories`,
    axiosToken(),

    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
  );
};

const createSubCategories = async (
  category,
  subCategories,
  partId,
  status,
  status_revise,
  revise_time,
  old_sub_categories,
) => {
  return await axios.post(
    `${config.server}/api/sub-categories`,
    {
      data: {
        category: category,
        sub_categories: subCategories,
        part: partId,
        status: status,
        status_revise: status_revise,
        revise_time: revise_time,
        old_sub_categories: old_sub_categories,
      },
      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const getQuestion = async (id) => {
  return await axios.get(
    `${config.server}/api/questions?filters[sub_category][id][$eq]=${id}&populate[sub_category][populate][category]=*`,
    // `${config.server}/api/questions?filters[sub_category][id][$eq]=${id}&populate=*&sort[question]=asc`,

    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};
const getAllQuestion = async (id) => {
  return await axios.get(
    `${config.server}/api/questions?populate=*`,

    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const createQuestion = async (
  // cp_id,
  specMin,
  specMax,
  specCount,
  inspectionTool,
  // torelance,
  formatTorelance,
  torelance1,
  torelance2,
  sc_status,
  question,
  UCL_xBar,
  CL_xBar,
  LCL_xBar,
  UCL_rChart,
  CL_rChart,
  LCL_rChart,
  subCategory,
  status,
  formula,
  status_revise,
  revise_time,
  old_question,
) => {
  return await axios.post(
    `${config.server}/api/questions`,
    {
      data: {
        // cq_id: cp_id,
        spec_min: parseFloat(specMin),
        spec_max: parseFloat(specMax),
        specCount: parseFloat(specCount),
        inspectionTool: inspectionTool,
        formatTorelance: formatTorelance,
        torelance1: parseFloat(torelance1),
        torelance2: parseFloat(torelance2),
        sc_status: sc_status,
        question: question,
        UCL_Xbar: parseFloat(UCL_xBar),
        CL_Xbar: parseFloat(CL_xBar),
        LCL_Xbar: parseFloat(LCL_xBar),
        UCL_Rchart: parseFloat(UCL_rChart),
        CL_Rchart: parseFloat(CL_rChart),
        LCL_Rchart: parseFloat(LCL_rChart),
        sub_category: subCategory,
        status: status,
        formula: {
          data: formula,
        },
        status_revise: status_revise,
        revise_time: revise_time,
        old_question: old_question,
      },
      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const createPart = async (
  partName,
  partCode,
  sectionNumber,
  customer,
  status,
  usePartForAdmin,
) => {
  return await axios.post(
    `${config.server}/api/qc-parts?populate[old_parts][populate]=*`,
    {
      data: {
        part_name: partName,
        part_code: partCode,
        section_number: sectionNumber,
        customer: customer,
        status: status,
        revise_time: "0",
        usePartForAdmin: usePartForAdmin,
      },

      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const createPartForRevise = async (
  partName,
  partCode,
  customer,
  revise_time,
  old_part,
  status,
  usePartForAdmin,
) => {
  return await axios.post(
    `${config.server}/api/qc-parts`,
    {
      data: {
        part_name: partName,
        part_code: partCode,
        customer,
        revise_time: revise_time + 1,
        old_parts: old_part,
        status: status,
        usePartForAdmin: usePartForAdmin,
      },

      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const revise = async (
  revisionRecord,
  date,
  release_signature,
  release_id,
  revise_time,
  part_id,
) => {
  return await axios.post(
    `${config.server}/api/revises`,
    {
      data: {
        revisionRecord: revisionRecord,
        date: date,
        release_signature: release_signature,
        release_id: release_id,
        revise: parseInt(revise_time),
        part: part_id,
        revise_status: "1",
      },

      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const reviseForUpdate = async (
  revisionRecord,
  date,
  release_signature,
  release_id,
  revise_time,
  part_id,
) => {
  return await axios.post(
    `${config.server}/api/revises`,
    {
      data: {
        revisionRecord: revisionRecord,
        date: date,
        release_signature: release_signature,
        release_id: release_id,
        revise: parseInt(revise_time),
        part: part_id,
        revise_status: "1",
      },

      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const updatePart = async (
  partName,
  partCode,
  customer,
  id,
  status,
  usePartForAdmin,
) => {
  return await axios.put(
    `${config.server}/api/qc-parts/${id}`,
    {
      data: {
        part_name: partName,
        part_code: partCode,
        customer: customer,
        status: status,
        usePartForAdmin: usePartForAdmin,
      },

      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const updateRevisionRecord = async (id, status) => {
  return await axios.put(
    `${config.server}/api/revises/${id}`,
    {
      data: {
        revisionRecord: status,
      },

      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const updateReviseForResendPart = async (id, release_signature, releaseID) => {
  return await axios.put(
    `${config.server}/api/revises/${id}`,
    {
      data: {
        approver_id: null,
        checker_id: null,
        checker_signature: null,
        approver_signature: null,
        release_id: releaseID,
        release_signature: release_signature,
        revise_status: "1",
      },

      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const updatePartStatus = async (id, status) => {
  return await axios.put(
    `${config.server}/api/qc-parts/${id}`,
    {
      data: {
        status: status,
        // revise_time: revise_Time
      },

      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const deletePart = async (id) => {
  return await axios.delete(
    `${config.server}/api/upload/files/${id}`,
    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const findOnePart = async (id) => {
  return await axios.get(
    `${config.server}/api/qc-parts/${id}?[populate][sub_categories][populate]=*&[populate][sub_categories][populate][questions][populate]=*&[populate][sub_categories][populate][questions][populate][old_question][populate]=*&[populate][sub_categories][populate][old_sub_categories][populate]=*&[populate][sub_categories][populate][category][fields]=category&[populate][revise][populate]=*&[populate][image][populate]=*&populate[old_parts][populate]=*`,
    {
      ...axiosToken(),
      validateStatus: function (status) {
        return status < 500;
      },
    },
  );
};

const findOnePartForFromAddQuestion = async (id) => {
  return await axios.get(
    `${config.server}/api/qc-parts/${id}?populate[revise][fields]=revise_status&populate[image][fields]=url`,
    axiosToken(),
    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
  );
};

const findSubAndQuestionByPartId = async (partId) => {
  return await axios.get(
    `${config.server}/api/qc-parts/${partId}?populate[sub_categories][populate]=questions&populate[sub_categories][populate]=category`,
    axiosToken(),
    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
  );
};

const getPartName = async (partId) => {
  return await axios.get(
    `${config.server}/api/qc-parts/${partId}?[populate][sub_categories][populate][questions][populate][image]=*&[populate][sub_categories][populate][category]=*&[populate][image][populate]=*`,
    axiosToken(),
    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
  );
};

const findOnePartForUseName = async (id) => {
  return await axios.get(
    // `${config.server}/api/qc-parts/${id}?populate=*`,
    `${config.server}/api/qc-parts/${id}?populate[revise][populate]=*&populate[old_parts][fields]=part_name`,
    axiosToken(),
    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
  );
};

const findOnePartPopulateAll = async (id) => {
  return await axios.get(
    `${config.server}/api/qc-parts/${id}?populate[sub_categories][populate][questions]=*`,
    // `${config.server}/api/qc-parts/${id}?populate=*`,
    axiosToken(),
    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
  );
};

//populate[sub_categories][populate][questions][populate][old_question][populate]

const findOneRevise = async (id) => {
  return await axios.get(
    // `${config.server}/api/revises/${id}?populate[release_id][populate]=*&populate[checker_id][populate]=*&populate[approver_id][populate]=*&populate[part][populate][image][populate]=*&populate[part][populate][sub_categories][populate]=*&populate[part][populate][old_parts][populate]=*&populate=*`,
    `${config.server}/api/revises/${id}?populate[release_id][populate][signature][fields]=url&populate[release_id][populate][profile_image][fields]=url&populate[part][populate][image][fields]=url&populate[part][populate][sub_categories][populate][questions][populate]=image&populate[part][populate][sub_categories][populate][category]=*&populate[checker_id][populate][signature][fields]=url&populate[checker_id][populate][profile_image][fields]=url&populate[approver_id][populate][signature][fields]=url&populate[approver_id][populate][profile_image][fields]=url`,
    axiosToken(),
    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
  );
};

const updateCheckerForRevise = async (
  reviseID,
  checkerSignatureURL,
  status,
  checkerID,
  remark,
) => {
  return await axios.put(`${config.server}/api/revises/${reviseID}`, {
    data: {
      checker_id: checkerID,
      checker_signature: checkerSignatureURL,
      revise_status: status,
      remark: remark,
    },
  });
};

const updateApproverForRevise = async (
  reviseID,
  approverSignatureURL,
  status,
  approverID,
  remark,
  // revise_time
) => {
  return await axios.put(`${config.server}/api/revises/${reviseID}`, {
    data: {
      approver_id: approverID,
      approver_signature: approverSignatureURL,
      revise_status: status,
      remark: remark,
      // revise: revise_time
    },
  });
};

const findOneQuestion = async (questionID) => {
  return await axios.get(
    `${config.server}/api/questions/${questionID}`,
    {
      ...axiosToken(),
      validateStatus: function (status) {
        return status < 500;
      },
    },
  );
};

const findOneSubCat = async (subCatID) => {
  return await axios.get(
    // `${config.server}/api/sub-categories?filters[part][id][$eq]=${id}&populate[questions][populate]=*&populate[part][populate]=*&populate[category][populate]=*`,
    `${config.server}/api/sub-categories/${subCatID}?&populate=*`,
    axiosToken(),
    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
  );
};

const updateSubCategory = async (
  category,
  subCategory,
  id,
  status,
  status_revise,
) => {
  return await axios.put(
    `${config.server}/api/sub-categories/${id}`,
    {
      data: {
        category: category,
        sub_categories: subCategory,
        status: status,
        status_revise: status_revise,
      },

      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const updateDeleteSubCategory = async (id, status) => {
  return await axios.put(
    `${config.server}/api/sub-categories/${id}`,
    {
      data: {
        status: status,
      },

      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const updateQuestion = async (
  question_data,
  // torelance,
  formatTorelance,
  torelance1,
  torelance2,
  specCount,
  inspectionTool,
  spec_min,
  spec_max,
  sc_status,
  id,
  status,
  UCL_xBar,
  CL_xBar,
  LCL_xBar,
  UCL_rChart,
  CL_rChart,
  LCL_rChart,
  formula,
  status_revise,
) => {
  return await axios.put(
    `${config.server}/api/questions/${id}`,
    {
      data: {
        question: question_data,
        spec_min: parseFloat(spec_min),
        spec_max: parseFloat(spec_max),
        formatTorelance: formatTorelance,
        torelance1: parseFloat(torelance1),
        torelance2: parseFloat(torelance2),
        specCount: parseFloat(specCount),
        inspectionTool: inspectionTool,
        sc_status: sc_status,
        status: status,
        UCL_Xbar: parseFloat(UCL_xBar),
        CL_Xbar: parseFloat(CL_xBar),
        LCL_Xbar: parseFloat(LCL_xBar),
        UCL_Rchart: parseFloat(UCL_rChart),
        CL_Rchart: parseFloat(CL_rChart),
        LCL_Rchart: parseFloat(LCL_rChart),
        formula: {
          data: formula,
        },
        status_revise: status_revise,
      },

      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const updateFormulaInQuestion = async (id, formula) => {
  return await axios.put(
    `${config.server}/api/questions/${id}`,
    {
      data: {
        formula: {
          data: formula,
        },
      },

      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const createAnswer = async (
  paper_id,
  question_id,
  actual,
  comment,
  answer,
  // user_id,
) => {
  return await axios.post(
    `${config.server}/api/answers`,
    {
      data: {
        paper_id: paper_id,
        question_id: question_id,
        actual: parseFloat(actual),
        comment: comment,
        answer: answer,
        // user_id: user_id,
      },

      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const createPaper = async (
  answer,
  partID,
  inspector_id,
  shift,
  create_datetime,
  date,
  time,
  // shiftAB,
  inspectorSignature,
  process_status,
  jobNumber,
  machineNumber,
) => {
  return await axios.post(
    `${config.server}/api/papers`,
    {
      data: {
        answer: answer,
        partName: partID,
        inspector_id: inspector_id,
        // time: time,
        shift: shift,
        create_datetime: create_datetime,
        date: date,
        time: time,
        // shiftAB: shiftAB,
        status: "1",
        signature_inspector: inspectorSignature,
        process_status: process_status,
        jobNumber: jobNumber,
        machineNumber: machineNumber,
        // cavity: cavity,
        // approver_id: approver_id,
        // checker_id: checker_id,
      },
      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const getPaper = async (beforeDate, afterDate, id, user) => {
  let url = `/api/papers?sort=create_datetime:ASC&filters[create_datetime][$gte]=${beforeDate}&filters[create_datetime][$lt]=${afterDate}&filters[partName][id][$eq]=${id}&filters[delete][$eq]=false&populate=*`;
  if (user?.qc_role === "inspector" && user?.id) {
    url = `/api/papers?sort=create_datetime:ASC&filters[create_datetime][$gte]=${beforeDate}&filters[create_datetime][$lt]=${afterDate}&filters[partName][id][$eq]=${id}&filters[delete][$eq]=false&filters[inspector_id][id][$eq]=${user.id}&populate=*`;
  }

  return await axios.get(
    `${config.server}${url}`,
    {
      ...axiosToken(),
      validateStatus: function (status) {
        return status < 500;
      },
    },
  );
};

const getPaperForReport = async (beforeDate, afterDate, id, user) => {
  let url = `/api/papers?sort=create_datetime:ASC&filters[create_datetime][$gte]=${beforeDate}&filters[create_datetime][$lt]=${afterDate}&filters[partName][id][$eq]=${id}&filters[delete][$eq]=false&populate=*`;
  if (user?.qc_role === "inspector" && user?.id) {
    url = `/api/papers?sort=create_datetime:ASC&filters[create_datetime][$gte]=${beforeDate}&filters[create_datetime][$lt]=${afterDate}&filters[partName][id][$eq]=${id}&filters[delete][$eq]=false&filters[inspector_id][id][$eq]=${user.id}&populate=*`;
  }

  return await axios.get(
    `${config.server}${url}`,
    {
      ...axiosToken(),
      validateStatus: function (status) {
        return status < 500;
      },
    },
  );
};

const getPaperHistory = async (beforeDate, afterDate, id, user) => {
  const fields = [
    "fields[0]=create_datetime",
    "fields[1]=status",
    "fields[2]=machineNumber",
    "fields[3]=delete",
  ].join("&");

  const populate = [
    "populate[inspector_id][fields][0]=name",
    "populate[inspector_id][fields][1]=lastname",
    "populate[inspector_id][fields][2]=username",
    "populate[checker_id][fields][0]=name",
    "populate[checker_id][fields][1]=lastname",
    "populate[checker_id][fields][2]=username",
    "populate[approver_id][fields][0]=name",
    "populate[approver_id][fields][1]=lastname",
    "populate[approver_id][fields][2]=username",
    "populate[partName][fields][0]=part_name",
    "populate[partName][fields][1]=part_code",
  ].join("&");

  let url = `/api/papers?sort=create_datetime:ASC&filters[create_datetime][$gte]=${beforeDate}&filters[create_datetime][$lt]=${afterDate}&filters[partName][id][$eq]=${id}&filters[delete][$eq]=false&${fields}&${populate}&pagination[pageSize]=1000`;
  if (user?.qc_role === "inspector" && user?.id) {
    url = `/api/papers?sort=create_datetime:ASC&filters[create_datetime][$gte]=${beforeDate}&filters[create_datetime][$lt]=${afterDate}&filters[partName][id][$eq]=${id}&filters[delete][$eq]=false&filters[inspector_id][id][$eq]=${user.id}&${fields}&${populate}&pagination[pageSize]=1000`;
  }

  return await axios.get(
    `${config.server}${url}`,
    {
      ...axiosToken(),
      validateStatus: function (status) {
        return status < 500;
      },
    },
  );
};

const getAllPaper = async () => {
  let url = `/api/papers?populate=*`;
  // if (user.qc_role === "inspector") {
  //   url = `/api/papers?sort=create_datetime:ASC&filters[create_datetime][$gte]=${beforeDate}&filters[create_datetime][$lt]=${afterDate}&filters[partName][id][$eq]=${id}&filters[delete][$eq]=false&filters[inspector_id][id][$eq]=${user.id}&populate=*`;
  // }

  return await axios.get(
    `${config.server}${url}`,
    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const getAllPaperCheckNull = async (section, page = 1, pageSize = 100, search = "", statusFilter = "", order = "desc", orderBy = "create_datetime", role = "", startDate = "", endDate = "") => {
  const baseUrl = config.server.replace(/\/$/, "");
  let url = `${baseUrl}/api/papers/getPendingList?section=${section}&page=${page}&pageSize=${pageSize}&order=${order}&orderBy=${orderBy}`;

  if (role) {
    url += `&role=${encodeURIComponent(role)}`;
  }

  if (startDate) {
    url += `&startDate=${encodeURIComponent(startDate)}`;
  }

  if (endDate) {
    url += `&endDate=${encodeURIComponent(endDate)}`;
  }

  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }

  if (statusFilter) {
    if (Array.isArray(statusFilter)) {
      url += `&statusFilter=${statusFilter.join(",")}`;
    } else {
      url += `&statusFilter=${statusFilter}`;
    }
  }

  try {
    const response = await axios.get(url, {
      ...axiosToken(),
      validateStatus: (status) => status < 500,
    });

    if (response.data && response.data.data) {
      return {
        data: response.data.data,
        total: response.data.meta.pagination.total,
        page: response.data.meta.pagination.page,
        pageCount: response.data.meta.pagination.pageCount,
      };
    }
    return { data: [], total: 0, page: 1, pageCount: 1 };
  } catch (error) {
    console.error(
      "Error fetching papers:",
      error.response?.data || error.message,
    );
    return { data: [], total: 0, page: 1, pageCount: 1 };
  }
};

const getAllPaperFactory1Null = async (partId) => {
  const baseUrl = config.server.replace(/\/$/, "");
  const url = `${baseUrl}/api/papers/${partId}?populate[partName][populate][0]=image&filters[approver_id][id][$null]=true&filters[partName][section_number][$eq]=1&pagination[pageSize]=100&filters[create_datetime][$gte]=2025-01-01T00:00:00.000Z`;

  try {
    const response = await axios.get(url, {
      ...axiosToken(),
      validateStatus: (status) => status < 500,
    });

    if (response.data && response.data.data) {
      return {
        data: response.data.data,
        total: response.data.meta.pagination.total,
      };
    }
    return { data: [], total: 0 };
  } catch (error) {
    console.error(
      "Error fetching papers:",
      error.response?.data || error.message,
    );
    return { data: [], total: 0 };
  }
};

const findOnePaper = async (id) => {
  return await axios.get(
    `${config.server}/api/papers/${id}?populate[approver_id][populate]=*&populate[answer][populate]=*&populate[checker_id][populate]=*&populate[inspector_id][populate]=*&populate[partName][populate][sub_categories][populate][questions][populate][image]=*&populate[partName][populate][sub_categories][populate][category]=*&populate[partName][populate][revise][populate]=*&populate[partName][populate][image][populate]=*&populate[partName][populate][old_parts][populate]=*&populate[partName][populate][old_parts][populate][revise][populate]=*&populate[partName][populate][old_parts][populate][revise][populate][checker_id][populate]=*&populate[partName][populate][old_parts][populate][revise][populate][release_id][populate]=*&populate[partName][populate][old_parts][populate][revise][populate][approver_id][populate]=*&populate[partName][populate][old_parts][populate][sub_categories][populate][questions][populate][image]=*&populate[partName][populate][old_parts][populate][sub_categories][populate][category]=*`,
    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const findOnePaperForViewPaper = async (id) => {
  return await axios.get(
    `${config.server}/api/papers/${id}?populate[answer][populate]=*&populate[approver_id][populate][profile_image][fields]=url&populate[approver_id][populate][signature][fields]=url&populate[checker_id][populate][profile_image][fields]=url&populate[checker_id][populate][signature][fields]=url&populate[inspector_id][populate][profile_image][fields]=url&populate[inspector_id][populate][signature][fields]=url&populate[partName][populate][sub_categories][populate][questions][populate][image]=*&populate[partName][populate][sub_categories][populate][category]=*&populate[partName][populate][revise][populate]=*&populate[partName][populate][image][populate]=*&populate[partName][populate][old_parts][populate]=*`,
    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const findOnePaperForEditPaper = async (id) => {
  return await axios.get(
    // `${config.server}/api/papers/${id}?populate[approver_id][populate]=*&populate[answer][populate]=*&populate[checker_id][populate]=*&populate[inspector_id][populate]=*&populate[partName][populate][sub_categories][populate]=*&populate[partName][populate][revise][populate]=*&populate[partName][populate][image][populate]=*&populate[partName][populate][old_parts][populate]=*&populate[partName][populate][old_parts][populate][revise][populate]=*&populate[partName][populate][old_parts][populate][revise][populate][checker_id][fields]=name&populate[partName][populate][old_parts][populate][revise][populate][release_id][fields]=name&populate[partName][populate][old_parts][populate][revise][populate][approver_id][fields]=name&populate=*`,
    // `${config.server}/api/papers/${id}?populate[approver_id][populate][signature][fields]=url&populate[approver_id][populate][profile_image][fields]=url&populate[checker_id][populate][signature][fields]=url&populate[checker_id][populate][profile_image][fields]=url&populate[inspector_id][populate][signature][fields]=url&populate[inspector_id][populate][profile_image][fields]=url&populate=partName`,
    `${config.server}/api/papers/${id}?populate[approver_id][populate][signature][fields]=url&populate[approver_id][populate][profile_image][fields]=url&populate[checker_id][populate][signature][fields]=url&populate[checker_id][populate][profile_image][fields]=url&populate[inspector_id][populate][signature][fields]=url&populate[inspector_id][populate][profile_image][fields]=url&populate[partName][populate][sub_categories][populate][questions][populate][image]=*&populate[partName][populate][sub_categories][populate][category]=*`,
    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const updateDeletePaper = async (deleteAnswer, id) => {
  return await axios.put(
    `${config.server}/api/papers/${id}`,
    {
      data: {
        delete: deleteAnswer,
      },

      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const updateDeletePart = async (usePartForAdmin, status, id) => {
  return await axios.put(
    `${config.server}/api/qc-parts/${id}`,
    {
      data: {
        usePartForAdmin: usePartForAdmin,
        status: status,
      },

      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const updatePaper = async (
  answer,
  id,
  process_status,
  machineNumber,
  jobNumber,
) => {
  return await axios.put(
    `${config.server}/api/papers/${id}`,
    {
      data: {
        answer: answer,
        // shiftAB: shiftAB,
        process_status: process_status,
        jobNumber: jobNumber,
        machineNumber: machineNumber,
        checker_id: null,
        approver_id: null,
        signature_checker: null,
        signature_approver: null,
        status: "1",
      },

      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const updateCheckerInPaper = async (
  paperID,
  checkerSignatureURL,
  status,
  checkerID,
  remark,
) => {
  return await axios.put(`${config.server}/api/papers/${paperID}`, {
    data: {
      checker_id: checkerID,
      signature_checker: checkerSignatureURL,
      status: status,
      remark: remark,
    },
  });
};

const updateApproverInPaper = async (
  paperID,
  approverSignatureURL,
  status,
  approverID,
  remark,
) => {
  return await axios.put(`${config.server}/api/papers/${paperID}`, {
    data: {
      approver_id: approverID,
      signature_approver: approverSignatureURL,
      status: status,
      remark: remark,
    },
  });
};

const replaceUserImageAtIndex0 = async (formData, part) => {
  try {
    const headers = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("QCAPPjwt"),
        "Content-Type": "multipart/form-data",
      },
    };

    // Step 1: Upload the new image first
    const response = await axios.post(
      `${config.server}/api/upload`,
      formData,
      headers,
    );

    if (response.data && response.data.length > 0) {
      const uploadedImage = response.data[0]; // Get the newly uploaded image data
      console.log("New image uploaded successfully:", uploadedImage);

      // Step 2: Now delete the old image at index [0] if it exists
      if (part.image?.data?.[0]) {
        const oldImageId = part.image.data[0].id;
        console.log("Removing old image with ID:", oldImageId);

        // Remove the old image from the backend
        await axios.delete(
          `${config.server}/api/upload/files/${oldImageId}`,
          headers,
        );
        console.log("Old image removed at index [0]");
      }

      // Step 3: Explicitly reset the image array to ensure no appending
      // Clear the image array and set only the new image at index[0]
      part.image.data = [uploadedImage];
      console.log(
        "Image array reset, new image set at index [0]:",
        part.image.data[0],
      );

      return uploadedImage; // Return the newly uploaded image
    } else {
      throw new Error("Upload failed: No image data returned.");
    }
  } catch (error) {
    console.error("Error replacing image at index [0]:", error);
    throw error; // Propagate the error
  }
};

const addUserImage = async (formData) => {
  try {
    const headers = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("QCAPPjwt"),
        "Content-Type": "multipart/form-data",
      },
    };
    console.log("Starting Upload for:", `${config.server}/api/upload`);
    return axios
      .post(`${config.server}/api/upload`, formData, headers)
      .then((res) => {
        console.log("Upload Success Response:", res.data);
        return res;
      })
      .catch((err) => {
        console.error(
          "Upload Error Details:",
          err.response?.data || err.message,
        );
        throw err;
      });
  } catch (error) {
    console.log(error);
  }
};

const deleteExistImages = async (partId, index) => {
  try {
    const headers = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("QCAPPjwt"),
        "Content-Type": "multipart/form-data",
      },
    };
    return axios
      .delete(
        `${config.server}/api/api/qc-parts/${partId}/image/${index}`,
        headers,
      )
      .then(console.log("Delete Success"));
  } catch (error) {
    console.log(error);
  }
};

const removeUserOldImage = async (id) => {
  console.log(id);

  try {
    // Make sure id is not undefined or null before proceeding
    if (!id) {
      throw new Error("ID is undefined or null");
    }

    // Call axios delete request with the id and token
    const response = await axios.delete(
      `${config.server}/api/upload/files/${id}`,
      axiosToken(),
    );

    // Log the response for debugging
    console.log("File successfully deleted", response.data);

    return response.data; // Return the response if needed
  } catch (e) {
    // Catch and log any errors
    console.log("Error deleting file", e);
  }
};

const getEssImage = async (imagePath) => {
  const resType = { responseType: "blob" };

  return await axios.get(config.ess + imagePath, resType);
}

const fetcher = (url) =>
  axios
    .get(`${config.server}${url}`, axiosToken(), {
      validateStatus: function (status) {
        return status < 500;
      },
    })
    .then((res) => res);

function multiFetcher(urls) {
  return Promise.all(
    urls.map((url) => {
      return fetcher(url);
    }),
  );
}

const useAllFetch = (url) => {
  return useSWR(url, multiFetcher, {
    refreshInterval: 600000,
  });
};

const useUser = () => {
  const { data, error, isLoading, mutate } = useSWRImmutable(
    // `/api/users?populate=*`,
    // `/api/users?sort[0]=id&populate=*`,
    `/api/users?sort[0]=id&populate[profile_image]=*&populate[signature]=*`,
    fetcher,
    {
      refreshInterval: 600000,
    },
  );
  return { data, error, isLoading, mutate };
};

const useOneUser = (id) => {
  const { data, error, isLoading, mutate } = useSWRImmutable(
    `/api/users/${id}?populate[signature]=*&populate[profile_image]=*`,
    fetcher,
    {
      refreshInterval: 600000,
    },
  );
  if (data) {
    if (data.data.signature) {
      data.data.signature.sort((a, b) => a.id - b.id);
    }
  }
  return { data, error, isLoading, mutate };
};

const getUrlPaper = (beforeDate, afterDate, id) => {
  return `/api/papers?filters[create_datetime][$gte]=${beforeDate}&filters[create_datetime][$lt]=${afterDate}&filters[partName][id][$eq]=${id}&filters[delete][$eq]=false`;
};

const usePartWithImage = (searchTerm = "") => {
  let url = `/api/qc-parts?sort[0]=id&filters[status][$eq]=true&filters[revise][revise_status][$eq]=4&populate[image][fields]=url&populate[old_parts][populate]=revise&pagination[pageSize]=1000`;

  if (searchTerm && searchTerm.trim() !== "") {
    const encodedSearchTerm = encodeURIComponent(searchTerm.trim());
    url += `&filters[$or][0][part_name][$containsi]=${encodedSearchTerm}&filters[$or][1][part_code][$containsi]=${encodedSearchTerm}`;
  }

  const { data, error, isLoading, mutate } = useSWR(url, fetcher, {
    refreshInterval: 60000,
  });
  return { data, error, isLoading, mutate };
};

const usePart = () => {
  const { data, error, isLoading, mutate } = useSWR(
    // `/api/qc-parts?populate=*&sort[0]=id&filters[status][$eq]=true`,
    // `/api/qc-parts?sort[0]=id&filters[status][$eq]=true&populate[sub_categories][populate][questions][populate]=*&populate=*`,
    `/api/qc-parts?sort[0]=id&filters[status][$eq]=true&filters[revise][revise_status][$eq]=4&populate[sub_categories][populate][questions][populate]=*&populate[image]=*&populate[revise][populate]=*&populate[old_parts][populate]=*`,
    // `/api/qc-parts?sort[0]=id&filters[status][$eq]=true&populate[sub_categories][populate][questions][populate]=*&populate[image]=*&populate[revise][populate]=*&populate=*`,

    fetcher,
    {
      refreshInterval: 30000,
    },
  );
  return { data, error, isLoading, mutate };
};

const getPartForPaper = async () => {
  return await axios.get(
    `${config.server}/api/qc-parts?sort[0]=id&filters[status][$eq]=true&filters[revise][revise_status][$eq]=4&populate[sub_categories][populate][questions][populate]=*&populate[image]=*&populate[revise][populate]=*`,
    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );

  // const { data, error, isLoading, mutate } = useSWRImmutable(
  //   // `/api/qc-parts?populate=*&sort[0]=id&filters[status][$eq]=true`,
  //   // `/api/qc-parts?sort[0]=id&filters[status][$eq]=true&populate[sub_categories][populate][questions][populate]=*&populate=*`,
  //   `/api/qc-parts?sort[0]=id&filters[status][$eq]=true&filters[revise][revise_status][$eq]=4&populate[sub_categories][populate][questions][populate]=*&populate[image]=*&populate[revise][populate]=*&populate=*`,
  //   // `/api/qc-parts?sort[0]=id&filters[status][$eq]=true&populate[sub_categories][populate][questions][populate]=*&populate[image]=*&populate[revise][populate]=*&populate=*`,

  //   fetcher,
  //   {
  //     refreshInterval: 60000,
  //   }
  // );
  // return { data, error, isLoading, mutate };
};

const getPartForDashboard = async (
  page = 1,
  pageSize = 30,
  searchTerm = "",
) => {
  try {
    // Build base filters
    const baseFilters = `filters[status][$eq]=true&filters[revise][revise_status][$eq]=4`;

    // Build search filter for part_name (big font) and part_code (small font) as requested by the user
    let searchFilter = "";
    if (searchTerm && searchTerm.trim() !== "") {
      const encodedSearchTerm = encodeURIComponent(searchTerm.trim());
      searchFilter = `&filters[$or][0][part_name][$containsi]=${encodedSearchTerm}&filters[$or][1][part_code][$containsi]=${encodedSearchTerm}`;
    }

    const url = `${config.server}/api/qc-parts?pagination[page]=${page}&pagination[pageSize]=${pageSize}&${baseFilters}${searchFilter}&populate[image]=*&populate[revise]=*&populate[old_parts][populate][revise]=*&sort=part_name:ASC`;

    const response = await axios.get(
      url,
      {
        validateStatus: function (status) {
          return status < 500;
        },
      },
      axiosToken(),
    );

    return response;
  } catch (error) {
    console.error("Error fetching parts for dashboard:", error);
    throw error;
  }
};

const usePaper = (beforeDate, afterDate, id, user) => {
  let url = `/api/papers?sort=create_datetime:ASC&filters[create_datetime][$gte]=${beforeDate}&filters[create_datetime][$lt]=${afterDate}&filters[partName][id][$eq]=${id}&filters[delete][$eq]=false&populate=*`;
  if (user.qc_role === "inspector") {
    url = `/api/papers?sort=create_datetime:ASC&filters[create_datetime][$gte]=${beforeDate}&filters[create_datetime][$lt]=${afterDate}&filters[partName][id][$eq]=${id}&filters[delete][$eq]=false&filters[inspector_id][id][$eq]=${user.id}&populate=*`;
  }
  const { data, error, isLoading, mutate } = useSWR(url, fetcher, {
    refreshInterval: 60000,
  });
  return { data, error, isLoading, mutate };
};

const updateUser = async ({ name, lastname, role, id, email, blocked }) => {
  return await axios.put(
    `${config.server}/api/users/${id}`,
    {
      email: email,
      name: name,
      lastname: lastname,
      qc_role: role,
      blocked: !blocked,
    },
    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};
const addUser = async ({ name, lastname, role, email, username, password }) => {
  return await axios.post(
    `${config.server}/api/users`,
    {
      email,
      name: name,
      lastname: lastname,
      qc_role: role,
      password,
      username: username.toUpperCase(),
      role: 1,
    },
    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const createSetting = async (time) => {
  return await axios.post(
    `${config.server}/api/settings`,
    {
      data: {
        timeToSendEmail: time,
      },

      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const updateSetting = async (setting, id) => {
  return await axios.put(
    `${config.server}/api/settings/${id}`,
    {
      data: setting,
      validateStatus: function (status) {
        return status < 500;
      },
    },
    axiosToken(),
  );
};

const getSetting = async () => {
  return await axios.get(`${config.server}/api/settings`, axiosToken(), {
    validateStatus: function (status) {
      return status < 500;
    },
  });
};

const findRevise = async () => {
  return await axios.get(
    // `${config.server}/api/revises?sort[id]=desc&populate=*`,
    `${config.server}/api/revises?sort[id]=desc&populate=*&filters[part][usePartForAdmin][$eq]=true`,
    axiosToken(),
    {
      validateStatus: function (status) {
        return status < 500;
      },
    },
  );
};

const sendEmailNG = async (ng) => {
  if (!Array.isArray(ng)) {
    throw Error("ng should be array type").stack;
  }
  return await axios({
    method: "POST",
    url: `${config.orgServer}/api/sendemailbytemplate`,
    data: {
      to: "sawanon.w@aapico.com",
      templateReferenceId: "11",
      data: {
        ng: ng,
      },
    },
  });
};

const getManyPaper = async (papersId) => {
  if (!Array.isArray(papersId)) {
    throw Error("papersId should be array type");
  }
  return await axios({
    method: "POST",
    url: `${config.server}/api/papers/getManyPaper`,
    data: {
      papersId,
    },
  });
};

const getDetailPart = async (partId) => {
  if (!partId) {
    throw Error("required partId");
  }
  return await axios({
    method: "GET",
    url: `${config.server}/api/qc-parts/getDetailPart/${partId}`,
  });
};

const createQuestionRevise = async (question) => {
  return await axios({
    url: `${config.server}/api/questions`,
    method: "POST",
    data: {
      data: {
        ...question,
      },
    },
    ...axiosToken(),
  });
};

const createSubcategoryRevise = async (subcategory) => {
  return await axios({
    url: `${config.server}/api/sub-categories`,
    method: "POST",
    data: {
      data: {
        ...subcategory,
      },
    },
    ...axiosToken(),
  });
};

const createPartRevise = async (part) => {
  return await axios({
    url: `${config.server}/api/qc-parts`,
    method: "POST",
    data: {
      data: {
        ...part,
      },
    },
    ...axiosToken(),
  });
};

const createRevise = async (reviseData) => {
  return await axios({
    url: `${config.server}/api/revises`,
    method: "POST",
    data: {
      data: {
        ...reviseData,
      },
    },
    ...axiosToken(),
  });
};

const updateStatusPart = async (partId, status, usePartForAdmin) => {
  return await axios({
    url: `${config.server}/api/qc-parts/${partId}`,
    method: "PUT",
    data: {
      data: {
        status,
        usePartForAdmin,
      },
    },
    ...axiosToken(),
  });
};

const deleteUser = async (userId) => {
  return await axios({
    url: `${config.server}/api/users/${userId}`,
    method: "DELETE",
    ...axiosToken(),
  });
};

export { useUser, useOneUser };

export const APIServices = {
  essUser,
  authQCUser,
  getQCUser,
  getPart,
  getPartSlim,
  getPartByID,
  getPartByIdArray,
  getSubCategoriesAddCategoriesPage,
  getSubCategories,
  getSubCategoriesByPartIdSlim,
  getSubCategoriesForViewPaperByPartId,
  getSubCategoriesForDashboard,
  getSubCategoriesSlim,
  getCategories,
  createSubCategories,
  getQuestion,
  createQuestion,
  addUserImage,
  getEssImage,
  removeUserOldImage,
  useUser,
  updateUser,
  deleteUser,
  updateDeleteSubCategory,
  getEssUserByUser,
  getEssEmployeeByUser,
  addUser,
  updatePart,
  deletePart,
  findOnePart,
  findOnePartForFromAddQuestion,
  findSubAndQuestionByPartId,
  getPartName,
  createPart,
  updateSubCategory,
  findOneSubCat,
  updateQuestion,
  createAnswer,
  createPaper,
  getPaper,
  getPaperHistory,
  updateDeletePaper,
  useAllFetch,
  usePartWithImage,
  usePart,
  getUrlPaper,
  getAllPaperCheckNull,
  getAllPaperFactory1Null,
  usePaper,
  findOnePaper,
  findOnePaperForViewPaper,
  findOnePaperForEditPaper,
  updatePaper,
  findOneQuestion,
  updateCheckerInPaper,
  updateApproverInPaper,
  createSetting,
  updateSetting,
  getSetting,
  revise,
  createPartForRevise,
  reviseForUpdate,
  findRevise,
  getAllPaper,
  getAllQuestion,
  findOneRevise,
  updateApproverForRevise,
  updateCheckerForRevise,
  updatePartStatus,
  updateFormulaInQuestion,
  getPartForDashboard,
  sendEmailNG,
  getPartForPaper,
  replaceUserImageAtIndex0,
  getPartWithRevise,
  updateDeletePart,
  findOnePartForUseName,
  findOnePartPopulateAll,
  updateRevisionRecord,
  getPaperForReport,
  updateReviseForResendPart,
  getManyPaper,
  getDetailPart,
  createQuestionRevise,
  createSubcategoryRevise,
  createPartRevise,
  createRevise,
  updateStatusPart,
  deleteExistImages,
};
